function parseDate(date: string): Date | null {
  const parts = date.split("-");

  if (parts.length !== 3) return null;

  let year: number;
  let month: number;
  let day: number;

  // YYYY-MM-DD
  if (parts[0].length === 4) {
    [year, month, day] = parts.map(Number);
  }
  // MM-DD-YYYY
  else if (parts[2].length === 4) {
    [month, day, year] = parts.map(Number);
  } else {
    return null;
  }

  const dateObj = new Date(Date.UTC(year, month - 1, day));

  // Validate (catches invalid dates like 02-31-2026)
  if (
    dateObj.getUTCFullYear() !== year ||
    dateObj.getUTCMonth() !== month - 1 ||
    dateObj.getUTCDate() !== day
  ) {
    return null;
  }

  return dateObj;
}

export const formatDate = (date: string) => {
  if (!date) return 'No Date Set';
  
  const dateObj = parseDate(date);
  if (!dateObj) return 'Invalid date';

  if (date == "1970-01-01") {
    return 'No Date Set';
  }
  
  return dateObj.toLocaleDateString('en-US', { 
    weekday: 'short', 
    month: 'long', 
    day: 'numeric',
    timeZone: 'UTC'
  });
}